import { FEATURE_FLAG_MAINTENANCE_REFERENCE_DOCUMENTS } from "./feature-flag-maintenance-reference-documents.mjs"

export const AUTHORING_ADMIN_MAINTENANCE_REFERENCE_DOCUMENTS = "authoringAdmin-maintenanceReferenceDocuments"

export const MAINTENANCE_REFERENCE_DOCUMENT_STATUS = {
    PLACEHOLDER: "PLACEHOLDER",
    CAPTURING: "CAPTURING",
    QUEUED: "QUEUED",
    GENERATING: "GENERATING",
    DRAFT: "DRAFT",
    PUBLISHED: "PUBLISHED",
    ERROR: "ERROR",
}

export const MAINTENANCE_REFERENCE_DOCUMENT_EMBEDDING_VERSION = 1
export const DEFAULT_CONTENT_CAPTURE_PASSCODE = "112112"

export const MAINTENANCE_REFERENCE_CAPTURE_PASSCODE =
    process.env.MAINTENANCE_REFERENCE_DOCUMENT_PASSCODE?.trim() ||
    process.env.CONTENT_CHECK_PASSCODE?.trim() ||
    DEFAULT_CONTENT_CAPTURE_PASSCODE
export const DEFAULT_MAINTENANCE_REFERENCE_DOCUMENT_MODEL = "gpt-5.4"

export const MAINTENANCE_REFERENCE_CHUNK_SIZE = +(process.env.MAINTENANCE_REFERENCE_DOCUMENT_CHUNK_SIZE ?? 4)
export const MAINTENANCE_REFERENCE_CHUNK_OVERLAP = +(process.env.MAINTENANCE_REFERENCE_DOCUMENT_CHUNK_OVERLAP ?? 1)
export const MAINTENANCE_REFERENCE_CHUNK_CONCURRENCY = +(
    process.env.MAINTENANCE_REFERENCE_DOCUMENT_CHUNK_CONCURRENCY ?? 4
)
export const MAINTENANCE_REFERENCE_GENERATION_STALE_MS = +(
    process.env.MAINTENANCE_REFERENCE_DOCUMENT_STALE_MS ?? 1000 * 60 * 15
)
export const MAINTENANCE_REFERENCE_RECOVERY_INTERVAL_MS = +(
    process.env.MAINTENANCE_REFERENCE_DOCUMENT_RECOVERY_INTERVAL_MS ?? 1000 * 30
)
export const MAINTENANCE_REFERENCE_MAX_COMPLETION_TOKENS = +(
    process.env.MAINTENANCE_REFERENCE_DOCUMENT_MAX_COMPLETION_TOKENS ?? 50000
)

export function getMaintenanceReferenceDocumentsRequiredDemands() {
    return [
        `$feature-${FEATURE_FLAG_MAINTENANCE_REFERENCE_DOCUMENTS}`,
        `$${AUTHORING_ADMIN_MAINTENANCE_REFERENCE_DOCUMENTS}`,
    ]
}
